import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface DamagePoint {
    x: number; // 0-100, porcentaje relativo al ancho de la imagen
    y: number; // 0-100, porcentaje relativo al alto de la imagen
    note?: string;
}

/**
 * Cada entrada se busca como palabra dentro del nombre de la unidad
 * (case-insensitive). Se evalua en orden, de la mas especifica a la mas
 * generica (p.ej. "RAM RAPID" antes que "RAM"), y se usa la primera que
 * haga match.
 */
const VEHICLE_IMAGE_BY_KEYWORD: Array<[string, string]> = [
    ['RAM RAPID', 'vehicle-diagram-ram-rapid.png'],
    ['RAM 1200', 'vehicle-diagram-ram-1200.png'],
    ['RAM', 'vehicle-diagram-ram.png'],
    ['TORTON(CHATO)', 'vehicle-diagram-torton-chato.png'],
    ['TORTON (CHATO)', 'vehicle-diagram-torton-chato.png'],
    ['TORTON', 'vehicle-diagram-torton.png'],
    ['TRACTO', 'vehicle-diagram-tracto.png'],
    ['PARTNER', 'vehicle-diagram-partner.png'],
    ['CRAFTER', 'vehicle-diagram-crafter.png'],
    ['NP300', 'vehicle-diagram-np300.png'],
    ['TOYOTA', 'vehicle-diagram-toyota.png'],
    ['MANAGER', 'vehicle-diagram-manager.png'],
    ['CAJA', 'vehicle-diagram-torton.png'],
];
const DEFAULT_VEHICLE_IMAGE = 'vehicle-diagram.png';

/**
 * Diagrama interactivo del vehiculo (Figma paso 2 "Unidad"): una sola imagen
 * compuesta con las 4 vistas del vehiculo (lado izquierdo/frente/lado
 * derecho/trasera). Tocar la imagen agrega un pin de daño en ese punto;
 * tocar un pin existente lo quita. La imagen mostrada depende de la marca/
 * modelo detectado en el nombre de la unidad (unitName), ya que ese nombre
 * es lo unico en el catalogo de unidades que distingue el modelo real
 * (el campo "type" de la unidad no es confiable para esto).
 */
@Component({
    selector: 'app-vehicle-damage-diagram',
    templateUrl: './vehicle-damage-diagram.component.html',
    styleUrls: ['./vehicle-damage-diagram.component.css']
})
export class VehicleDamageDiagramComponent {
    @Input() points: DamagePoint[] = [];
    @Input() readonly = false;
    @Input() unitName = '';
    @Output() pointsChange = new EventEmitter<DamagePoint[]>();

    get vehicleImage(): string {
        const name = (this.unitName || '').toUpperCase();
        const match = VEHICLE_IMAGE_BY_KEYWORD.find(([keyword]) => name.includes(keyword));
        return 'assets/img/departure-check/' + (match ? match[1] : DEFAULT_VEHICLE_IMAGE);
    }

    onImageClick(event: MouseEvent): void {
        if (this.readonly) return;
        const target = event.currentTarget as HTMLElement;
        const rect = target.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        const updated = [...this.points, { x, y }];
        this.points = updated;
        this.pointsChange.emit(updated);
    }

    removePoint(index: number, event: MouseEvent): void {
        event.stopPropagation();
        if (this.readonly) return;
        const updated = this.points.filter((_, i) => i !== index);
        this.points = updated;
        this.pointsChange.emit(updated);
    }
}
